import { ITask, ITaskResult, TInvokerStrategySettle } from '../TInvoker';
import OperationCanceledError from '../error/OperationCanceledError';
import TaskStatus from './TaskStatus';
import collectResult from './result/collectResult';

export default class TaskProcessor {
    constructor(private readonly tasks: ReadonlyArray<ITask>) {
    }

    // eslint-disable-next-line class-methods-use-this
    settleTask(task: ITask, result: ITaskResult): void {
        if (TaskStatus.isFinalStatus(task.status)) {
            return;
        }
        const item = task;
        item.result = result;
        TaskStatus.setFromResult(item, result);
    }

    cancelTasks(): void {
        this.tasks
            .forEach((task) => this.settleTask(task, {
                error: new OperationCanceledError({
                    description: `The task with the key '${task.key}' was canceled`,
                    task,
                }),
            }));
    }

    // eslint-disable-next-line class-methods-use-this
    setPending(task: ITask): void {
        TaskStatus.setPending(task);
    }

    collectResult(strategy?: TInvokerStrategySettle): any[] | unknown {
        return collectResult(this.tasks, strategy);
    }
}
